<template>
  <section class="vcenter">
    <form
      class="vcenter-form"
      @submit.prevent="login"
    >

      <h1>Entrez vos identifiants</h1>

      <b-message
        v-if="errorMessage"
        type="is-danger"
      >
        {{ errorMessage }}
      </b-message>

      <b-field label="Adresse email">
        <b-input
          v-model="email"
          type="email"
        />
      </b-field>
      <b-field label="Mot de passe">
        <b-input
          v-model="password"
          type="password"
        />
      </b-field>

      <div class="form-buttons">
        <button
          class="button is-primary"
          type="submit"
        >
          Valider
        </button>
        <div class="right">
          <router-link
            to="/password-reset"
            class="small"
          >
            Mot de passe oublié
          </router-link>
        </div>
      </div>

      <b-loading
        :active="loading"
        :is-full-page="false"
      />
    </form>
  </section>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      password: '',
      errorMessage: null,
      loading: false,
    }
  },
  created () {
    if (process.env.NODE_ENV === 'dev') {
      this.email = 'simon@tarchichi.com'
      this.password = 'test'
    }
  },
  methods: {
    async login () {
      this.errorMessage = null
      this.loading = true
      try {
        const data = await this.$api.post('/login', {
          email: this.email,
          password: this.password,
        })
        this.errorMessage = data.email + data.password
        if (!data || !data.token) {
          throw new Error('No token found')
        }
        await this.$store.dispatch('getUser', data.token)
        this.$router.push('/portefeuille')
      } catch (e) {
        if (e.response && e.response.data && e.response.data.error) {
          this.errorMessage = e.response.data.error
        } else {
          this.errorMessage += e.message || 'Erreur lors de la connexion'
        }
      }
      this.loading = false
    },
  }
}
</script>
